export interface StoreShelf {
  rank: number;

  pitchCm: number;
}

export interface StoreBay {
  bayNo: number;
  widthCm: number;
  heightCm: number;

  physicalBayNo?: number;

  shelfWidthCm?: number;

  deadRightCm?: number;
  deadLeftCm?: number;

  shelves: readonly StoreShelf[];
}

export interface StoreFixture {
  bays: readonly StoreBay[];
}

export interface StoreAssortmentItem {
  skuId: string;
  sales: number;
  minFacings: number;
  widthCm: number;
  heightCm: number;
}

export const shelfCmOf = (fixture: StoreFixture): number =>
  fixture.bays.reduce((sum, bay) => sum + bay.widthCm * bay.shelves.length, 0);

export const bayShelfCmOf = (bay: StoreBay): number => bay.widthCm * bay.shelves.length;

export const uniformFixture = (
  bays: number,
  shelves: number,
  options: { widthCm?: number; heightCm?: number } = {},
): StoreFixture => {
  // Only for a plan with no bays, where nothing is measured against it: a 48 in bay, 87.4 in
  // tall, in hundredths of an inch.
  const widthCm = options.widthCm ?? 4800;
  const heightCm = options.heightCm ?? 8740;
  const pitches =
    shelves === 6 && heightCm === 8740
      ? [1496, 1260, 1339, 1339, 1417, 1496]
      : Array.from({ length: shelves }, () => heightCm / shelves);
  return {
    bays: Array.from({ length: bays }, (_, index) => ({
      bayNo: index + 1,
      widthCm,
      heightCm,
      shelves: pitches.map((pitchCm, rank) => ({ rank: rank + 1, pitchCm })),
    })),
  };
};
